import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const HistoryFilters = ({ onFiltersChange, onExport, onClearFilters }) => {
  const [filters, setFilters] = useState({
    dateFrom: '',
    dateTo: '',
    status: '',
    searchTerm: '',
    fileType: ''
  });

  const statusOptions = [
    { value: '', label: 'Todos los estados' },
    { value: 'completed', label: 'Completado' },
    { value: 'failed', label: 'Fallido' },
    { value: 'in-progress', label: 'En progreso' },
    { value: 'cancelled', label: 'Cancelado' }
  ];

  const fileTypeOptions = [
    { value: '', label: 'Todos los tipos' },
    { value: 'csv', label: 'CSV' },
    { value: 'xlsx', label: 'Excel (XLSX)' },
    { value: 'xls', label: 'Excel (XLS)' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      dateFrom: '',
      dateTo: '',
      status: '',
      searchTerm: '',
      fileType: ''
    };
    setFilters(clearedFilters);
    onFiltersChange(clearedFilters);
    onClearFilters();
  };

  const hasActiveFilters = Object.values(filters)?.some(value => value !== '');

  return (
    <div className="bg-surface border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-text-primary flex items-center">
          <Icon name="Filter" size={20} className="mr-2" />
          Filtros de Búsqueda
        </h3>
        <div className="flex items-center space-x-2">
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={handleClearFilters}
              iconName="X"
              iconPosition="left"
            >
              Limpiar
            </Button>
          )}
          <Button
            variant="outline"
            size="sm"
            onClick={onExport}
            iconName="Download"
            iconPosition="left"
          >
            Exportar
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        <Input
          type="search"
          placeholder="Buscar por nombre de archivo..."
          value={filters?.searchTerm}
          onChange={(e) => handleFilterChange('searchTerm', e?.target?.value)}
          className="col-span-1 lg:col-span-2"
        />

        <Input
          type="date"
          label="Fecha desde"
          value={filters?.dateFrom}
          onChange={(e) => handleFilterChange('dateFrom', e?.target?.value)}
        />

        <Input
          type="date"
          label="Fecha hasta"
          value={filters?.dateTo}
          onChange={(e) => handleFilterChange('dateTo', e?.target?.value)}
        />

        <Select
          placeholder="Estado"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => handleFilterChange('status', value)}
        />

        <Select
          placeholder="Tipo de archivo"
          options={fileTypeOptions}
          value={filters?.fileType}
          onChange={(value) => handleFilterChange('fileType', value)}
          className="md:col-span-2 lg:col-span-1"
        />
      </div>
      {hasActiveFilters && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex flex-wrap gap-2">
            <span className="text-sm text-text-secondary">Filtros activos:</span>
            {filters?.searchTerm && (
              <span className="inline-flex items-center px-2 py-1 bg-primary/10 text-primary rounded-md text-sm">
                Búsqueda: "{filters?.searchTerm}"
                <button
                  onClick={() => handleFilterChange('searchTerm', '')}
                  className="ml-1 hover:bg-primary/20 rounded-full p-0.5"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
            {filters?.status && (
              <span className="inline-flex items-center px-2 py-1 bg-primary/10 text-primary rounded-md text-sm">
                Estado: {statusOptions?.find(opt => opt?.value === filters?.status)?.label}
                <button
                  onClick={() => handleFilterChange('status', '')}
                  className="ml-1 hover:bg-primary/20 rounded-full p-0.5"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
            {filters?.fileType && (
              <span className="inline-flex items-center px-2 py-1 bg-primary/10 text-primary rounded-md text-sm">
                Tipo: {fileTypeOptions?.find(opt => opt?.value === filters?.fileType)?.label}
                <button
                  onClick={() => handleFilterChange('fileType', '')}
                  className="ml-1 hover:bg-primary/20 rounded-full p-0.5"
                >
                  <Icon name="X" size={12} />
                </button>
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default HistoryFilters;